// material-icons-list.js
const materialIconsList = [
    "3d_rotation",
    "accessibility",
    "accessibility_new",
    "accessible",
    "accessible_forward",
    "account_balance",
    "account_balance_wallet",
    "account_box",
    "account_circle",
    "add_shopping_cart",
    "alarm",
    "alarm_add",
    "alarm_off",
    "alarm_on",
    "all_inbox",
    "all_out",
    "analytics",
    "anchor",
    "android",
    "announcement",
    "api",
    "app_blocking",
    "arrow_circle_down",
    "arrow_circle_up",
    "arrow_right",
    "arrow_right_alt",
    "article",
    "aspect_ratio",
    "assessment",
    "assignment",
    "assignment_ind",
    "assignment_late",
    "assignment_return",
    "assignment_returned",
    "assignment_turned_in",
    "autorenew",
    "backup",
    "backup_table",
    "batch_prediction",
    "book",
    "bookmark",
    "bookmark_border",
    "bookmarks",
    "bug_report",
    "build",
    "build_circle",
    "cached",
    "calendar_today",
    "calendar_view_day",
    "camera_enhance",
    "cancel_schedule_send",
    "card_giftcard",
    "card_membership",
    "card_travel",
    "change_history",
    "check_circle",
    "check_circle_outline",
    "chrome_reader_mode",
    "circle_notifications",
    "class",
    "close_fullscreen",
    "code",
    "comment_bank",
    "commute",
    "compare_arrows",
    "compress",
    "contact_page",
    "contact_support",
    "contactless",
    "copyright",
    "credit_card",
    "dangerous",
    "dashboard",
    "dashboard_customize",
    "data_exploration",
    "date_range",
    "delete",
    "delete_forever",
    "delete_outline",
    "description",
    "disabled_by_default",
    "dns",
    "done",
    "done_all",
    "done_outline",
    "donut_large",
    "donut_small",
    "drag_indicator",
    "dynamic_form",
    "eco",
    "edit",
    "edit_off",
    "eject",
    "euro_symbol",
    "event",
    "event_seat",
    "exit_to_app",
    "expand",
    "explore",
    "explore_off",
    "extension",
    "face",
    "face_unlock",
    "fact_check",
    "favorite",
    "favorite_border",
    "feedback",
    "file_present",
    "filter_alt",
    "find_in_page",
    "find_replace",
    "fingerprint",
    "fit_screen",
    "flaky",
    "flight_land",
    "flight_takeoff",
    "flip_to_back",
    "flip_to_front",
    "g_translate",
    "gavel",
    "get_app",
    "gif",
    "grade",
    "grading",
    "group_work",
    "help",
    "help_center",
    "help_outline",
    "highlight_alt",
    "highlight_off",
    "history",
    "history_toggle_off",
    "home",
    "horizontal_split",
    "hourglass_disabled",
    "hourglass_empty",
    "hourglass_full",
    "http",
    "https",
    "important_devices",
    "info",
    "input",
    "integration_instructions",
    "invert_colors",
    "label",
    "label_important",
    "label_off",
    "language",
    "launch",
    "leaderboard",
    "lightbulb",
    "line_style",
    "line_weight",
    "list",
    "lock",
    "lock_clock",
    "lock_open",
    "login",
    "logout",
    "loyalty",
    "manage_accounts",
    "mark_as_unread",
    "markunread_mailbox",
    "maximize",
    "mediation",
    "minimize",
    "model_training",
    "next_plan",
    "nightlight_round",
    "no_accounts",
    "not_accessible",
    "not_started",
    "note_add",
    "offline_bolt",
    "offline_pin",
    "online_prediction",
    "opacity",
    "open_in_browser",
    "open_in_full",
    "open_in_new",
    "open_with",
    "outbond",
    "outbox",
    "outlet",
    "pageview",
    "pan_tool",
    "payment",
    "pending",
    "pending_actions",
    "perm_camera_mic",
    "perm_contact_calendar",
    "perm_data_setting",
    "perm_device_information",
    "perm_identity",
    "perm_media",
    "perm_phone_msg",
    "perm_scan_wifi",
    "pets",
    "picture_in_picture",
    "picture_in_picture_alt",
    "pin_end",
    "pin_invoke",
    "plagiarism",
    "play_for_work",
    "polymer",
    "power_settings_new",
    "pregnant_woman",
    "preview",
    "print",
    "privacy_tip",
    "published_with_changes",
    "query_builder",
    "question_answer",
    "quickreply",
    "receipt",
    "record_voice_over",
    "redeem",
    "remove_done",
    "remove_shopping_cart",
    "reorder",
    "report_problem",
    "request_page",
    "restore",
    "restore_from_trash",
    "restore_page",
    "room",
    "rounded_corner",
    "rowing",
    "rule",
    "schedule",
    "search",
    "search_off",
    "segment",
    "send_and_archive",
    "sensors",
    "sensors_off",
    "settings",
    "settings_applications",
    "settings_backup_restore",
    "settings_bluetooth",
    "settings_brightness",
    "settings_cell",
    "settings_ethernet",
    "settings_input_antenna",
    "settings_input_component",
    "settings_input_composite",
    "settings_input_hdmi",
    "settings_input_svideo",
    "settings_overscan",
    "settings_phone",
    "settings_power",
    "settings_remote",
    "settings_voice",
    "shop",
    "shop_two",
    "shopping_bag",
    "shopping_basket",
    "shopping_cart",
    "smart_button",
    "source",
    "speaker_notes",
    "speaker_notes_off",
    "spellcheck",
    "star_rate",
    "stars",
    "sticky_note_2",
    "store",
    "subject",
    "subtitles_off",
    "supervised_user_circle",
    "supervisor_account",
    "support",
    "swap_horiz",
    "swap_vert",
    "swap_vertical_circle",
    "sync_alt",
    "system_update_alt",
    "tab",
    "tab_unselected",
    "table_view",
    "task_alt",
    "text_rotate_up",
    "text_rotate_vertical",
    "text_rotation_angledown",
    "text_rotation_angleup",
    "text_rotation_down",
    "text_rotation_none",
    "theaters",
    "thumb_down",
    "thumb_up",
    "thumbs_up_down",
    "timeline",
    "tips_and_updates",
    "title",
    "toc",
    "today",
    "toll",
    "touch_app",
    "tour",
    "track_changes",
    "translate",
    "trending_down",
    "trending_flat",
    "trending_up",
    "turned_in",
    "turned_in_not",
    "unarchive",
    "undo",
    "unfold_less",
    "unfold_more",
    "update",
    "update_disabled",
    "upgrade",
    "verified",
    "verified_user",
    "vertical_split",
    "view_agenda",
    "view_array",
    "view_carousel",
    "view_column",
    "view_comfy",
    "view_compact",
    "view_day",
    "view_headline",
    "view_in_ar",
    "view_list",
    "view_module",
    "view_quilt",
    "view_sidebar",
    "view_stream",
    "view_week",
    "visibility",
    "visibility_off",
    "voice_over_off",
    "watch_later",
    "wifi_protected_setup",
    "work",
    "work_off",
    "work_outline",
    "wysiwyg",
    "youtube_searched_for",
    "zoom_in",
    "zoom_out",
    "clock_loader_90",
    "clock_loader_20",
    "clock_loader_80",
];

// Exportar la lista para su uso en otros archivos
module.exports = materialIconsList;